import { CircularProgress, CircularProgressProps } from '@mui/material';

export function MuiCircularProgress(props: CircularProgressProps) {
  return <CircularProgress data-testid="circular-progress" {...props} />;
}
